import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

export const useRequestLdFlags = createFlagsHook<typeof import('./flags.json')>()
